module.exports = __webpack_public_path__ + "static/assets/c32065243477e3add5ac7e889d8048da.gif";